import moment from 'moment';
import { MONTHLY } from '../EmployeeDashboard/Mobile/constants';
import { MomentFormats } from '../../utils';
import { RequestStatus } from '../../Enums';

export const initPrivateOffersSummary = {
    new: 0,
    total: 0,
    offerIds: [],
    loadedIds: [],
}

export const initData = {
    monthlySchedule: [],
    weeklySchedule: [],
    employeeShifts: [],
    employeeShiftOffers: [],
    employeeShiftRequests: [],
    employeeMyShiftSwapOffers: [],
    availableShiftsToCover: [],
    availableShiftToSwapOffers: [],
    availableOpenShifts: [],
    myOpenShiftRequests: [],
    availableVTO: [],
    myVTORequests: [],
    myProposals: [],
    privateOffers: [],
    privateOffersSummary: initPrivateOffersSummary,
    validProposalShifts: [],
    proposableShiftsPerEmployee: {},
    globalHistory: [],
    employeePaycodes: [],
    timeOffRequestSubtypes: [],
}

export const initFilters = {
    myItem: {
        category: 0,
        filters: [{
            id: 0,
            name: 'My Shifts',
            bgColor: '#FFFFFF',
            borderColor: '#0A54A2',
            checked: true,
            parentCategory: 0,
            calendarIds: ['0'],
        },
        {
            id: 1,
            name: 'Paycodes',
            bgColor: '#FFFFFF',
            borderColor: '#07ad34',
            checked: true,
            parentCategory: 0,
            calendarIds: ['1'],
        },
        ],
    },
    skipValidationOffers: {
        category: 3,
        filters: [],
    },
    myRequest: {
        category: 1,
        filters: [],
    },
    status: {
        category: 2,
        filters: [
            {
                id: 2,
                name: 'Offered',
                bgColor: '#FFFFFF',
                borderColor: '#b68cdb',
                checked: true,
                statusIds: [RequestStatus.Offered],
                parentCategory: 2
            },
            {
                id: 3,
                name: 'Submitted',
                bgColor: '#FFFFFF',
                borderColor: '#9159c2',
                checked: true,
                statusIds: [RequestStatus.Submitted],
                parentCategory: 2
            },
            {
                id: 4,
                name: 'Pending',
                bgColor: '#FFFFFF',
                borderColor: '#fff000',
                checked: true,
                statusIds: [RequestStatus.Pending],
                parentCategory: 2
            },
            {
                id: 5,
                name: 'Approved',
                bgColor: '#FFFFFF',
                borderColor: '#07ad34',
                checked: true,
                statusIds: [RequestStatus.Approved],
                parentCategory: 2
            },
            {
                id: 6,
                name: 'Refused',
                bgColor: '#FFFFFF',
                borderColor: '#ff4040',
                checked: true,
                statusIds: [RequestStatus.Refused],
                parentCategory: 2
            },
            {
                id: 7,
                name: 'Retracted',
                bgColor: '#FFFFFF',
                borderColor: '#8a37d4',
                checked: true,
                statusIds: [RequestStatus.OfferRetracted, RequestStatus.RequestRetracted],
                parentCategory: 2
            },
            {
                id: 8,
                name: 'Expired',
                bgColor: '#FFFFFF',
                borderColor: '#ff572e',
                checked: true,
                statusIds: [RequestStatus.Expired],
                parentCategory: 2
            },
            {
                id: 9,
                name: 'Declined',
                bgColor: '#FFFFFF',
                borderColor: '#ff4040',
                checked: true,
                statusIds: [RequestStatus.Declined],
                parentCategory: 2
            },
            {
                id: 10,
                name: 'Auto-retracted',
                bgColor: '#FFFFFF',
                borderColor: '#8a37d4',
                checked: true,
                statusIds: [RequestStatus.AutoRetracted],
                parentCategory: 2
            },
        ]
    },
    location: {
        filters: [],
        isTransferIncluded: true
    },
    job: {
        filters: [],
        isTransferIncluded: true
    }
}

export const initCalendar = [
    {
        id: '0',
        name: 'My Shifts',
        bgColor: '#FFFFFF',
        borderColor: '#0A54A2',
    },
    {
        id: '1',
        name: 'Paycodes',
        color: '#555555',
        borderColor: '#48D960',
        bgColor: '#ffffff',
    },
]

export const initSnackbar = {
    typeSnackbar: 'success',
    messageSnackbar: '',
    openSnackbar: false,
}

export const initPersonInfo = {
    personNumber: 0,
    currentEmployeeId: 0,
    personName: '',
    primaryJob: '',
}

export const initDateRange = {
    startDate: (() => {
        // Default values - will be recalculated by component with correct week start day
        return moment.utc().startOf('month').format(MomentFormats.YMD);
    })(),
    endDate: (() => {
        // Default values - will be recalculated by component with correct week start day
        return moment.utc().endOf('month').format(MomentFormats.YMD);
    })(),
}

export const initMobileView = {
    previous: '',
    current: MONTHLY
}

export const initMobileOfferForm = {
    shifts: [],
    managerSetting: '',
    partialDates: {
        isPartial: false,
        startDate: moment.utc(),
        endDate: moment.utc()
    },
    proposalPartialDates: {
        isPartial: false,
        startDate: moment.utc(),
        endDate: moment.utc(),
        partialShiftLabel: '',
    },
    isPrivate: false,
    isProposedByOfferer: false,
    privateEmployeeSelected: [],
    source: 0,
    status: -1,
    type: -1,
    id: 0,
    offerId: 0,
    history: [],
    proposals: undefined,
    isValid: true,
    rawValidationDetails: [],
    raw: {},
    preferredDates: [],
    isAvailableOffer: false,
    commentToManager: '',
    proposalIdSelected: null,
    timeOffRequestSubtypeIdSelected: null,
    timeOffRequestReasonIdSelected: null,
}

export const initDismissData = {
    offerId: null,
    proposalId: null,
    isVTO: false,
    open: false
}

export const initOptions = {
    headers: {
        Authorization: sessionStorage.getItem('authToken') ?? '',
    }
};

export const initPartialDates = {
    startDate: moment.utc(),
    endDate: moment.utc(),
    selectedPartialLabel: ''
};

export const initPaycodeForm = { paycode: {} };

export const initGlobalConfigs = {
    postedRequestDisplay: 0,
    isShowOrganizationalPath: false,
    isLoaded: false
}

export const initBuildInfos = {
    version: "-",
    environment: "-"
}